// extracted by mini-css-extract-plugin
export default {"scrollbox":"static-React-HVJS-HVUI-Scrollbox-___Scrollbox-alone-module__scrollbox"};